// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label[data-v-d259dbe4]{padding-left:1ex;line-height:2.7ex;font-size:14px}\n", ""]);
// Exports
module.exports = exports;
